import type * as GraphQLTypes from '../../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePartnerMutationVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String'];
}>;


export type DeletePartnerMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deletePartner'>
);


export const DeletePartnerDocument = /*#__PURE__*/ gql`
    mutation deletePartner($id: String!) {
  deletePartner(id: $id)
}
    `;

/**
 * __useDeletePartnerMutation__
 *
 * To run a mutation, you first call `useDeletePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerMutation, { data, loading, error }] = useDeletePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerMutationResult, DeletePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerMutationResult, DeletePartnerMutationVariables>(DeletePartnerDocument, options);
      }
export type DeletePartnerMutationHookResult = ReturnType<typeof useDeletePartnerMutation>;